(function () {
  window.addEventListener('load', function (evt) {
    // This array is needed for comparison with the generated array of 
    // the current window location to be sure that the following adjustment
    // is only made on this specific page which ends on WEB.DE with `/quiz/portal` or on GMX with `/apps/quiz`
    const quizLocArrayWEBDE = ['portal', 'quiz']
    const quizLocArrayGMX = ['quiz', 'apps']
    const winLocArray = location.pathname.split('/').filter(Boolean).reverse().splice(0, 2)

    const equals = (a, b) =>
      a.length === b.length &&
      a.every((v, i) => v === b[i])

    if (!equals(quizLocArrayWEBDE, winLocArray) && !equals(quizLocArrayGMX, winLocArray)) {
      return
    }

    const addErrorMessage = (field, msg) => {
      if (!field) return
      let message = document.getElementById(field.id + '-error')
      const container = field.parentNode.parentNode.parentNode

      if (!message) {
        message = document.createElement('div')
        message.id = field.id + '-error'
        message.className = 'error message field'
        message.style.maxWidth = 'none'
        container.parentNode[container.nextSibling ? 'insertBefore' : 'appendChild'](message, container.nextSibling)
      }

      message.innerHTML = '<span class="m error icon"></span><span></span>'
      message.lastChild.appendChild(document.createTextNode(msg))
    }
    

    const prepareQuiz = () => {
      const form = document.querySelector('form.quiz')

      if (!form) return

      // can be used to apply additional styles via a separate css file
      document.getElementsByTagName('body')[0].setAttribute('data-theme', 'quiz')

      const formContainer = Array.from(form.querySelectorAll('[data-cc-sub="configurator"]'))
      const submitButton = document.querySelector('form.quiz [data-cc-sub="configurator"] button[type="submit"]')
      const invalidMessage = "Hier hat sich noch ein Fehler eingeschlichen - probieren Sie es doch gleich noch einmal."

      const onSubmitClick = (event) => {
        event.preventDefault()
        let hasError = false

        formContainer.slice(1, formContainer.length - 1).forEach(radioGroupContainer => {
          radioGroupContainer.querySelectorAll('input[type="radio"]').forEach(radioButton => {
            if (radioButton.value === "true" && !radioButton.checked) {
              addErrorMessage(radioButton, invalidMessage)
              hasError = true
            }
          })
        })

        if (!hasError) form.submit()
      }

    
      submitButton.addEventListener('click', onSubmitClick)
    }

    prepareQuiz()

  })
})()
